import { useGeoLocation } from '../../hooks/useGeoLocation';
import { useCallback } from 'react';
import { useLeafletMap } from './MapContext';

export const useMapTargetToUser = () => {
    const { userLocation } = useGeoLocation();
    const { zoomToLocation } = useLeafletMap();

    const targetToUser = useCallback(() => {
        if (userLocation?.lat && userLocation?.lng) {
            zoomToLocation(userLocation);
        }
    }, [userLocation, zoomToLocation]);

    return {
        targetToUser,
    };
};
